"use client";

import React from "react";
import Link from "next/link";
import styles from "./IntegrationSolutions.module.css";
import { integrationTiles as TILES } from "../../data/custom-software-integration";

export default function IntegrationSolutions() {
  return (
    <section className={`${styles.section} py-5`}>
      <div className="container">
        <div className={styles.wrap}>
          {/* Left copy */}
          <div className={styles.left} data-reveal="fade">
            <span className={styles.eyebrow}>INTEGRATION SERVICES</span>
            <h2 className={styles.title}>Our Integration Solutions</h2>
            <p className={styles.subtitle}>
              Connect your systems with reliable integrations that streamline
              data flow, enhance operations, and accelerate delivery.
            </p>
            <Link href="/contact" className={styles.cta}>
              Talk to Expert
            </Link>
          </div>

          {/* Right tiles */}
          <div className={styles.grid} data-reveal="stagger-mix">
            {TILES.map((t) => (
              <div key={t.label} className={styles.tile}>
                <span className={styles.icon} aria-hidden>
                  <i className={t.icon}></i>
                </span>
                <span className={styles.label}>
                  {String(t.label).replace(/\n/g, " ")}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
